import styled from 'styled-components';
import { getColor } from '../../../../../src/styled/utils';
import { Body2Styles } from '../../../typography';
export const Highlighted = styled.span `
  ${Body2Styles}
  color: ${getColor('link')};
  cursor: default;
`;
